import {
  BlockText,
  PriceCalculatorBlock,
  ThemeMenuFeaturedBlock,
} from '../implementations';

const mappers = {
  text: BlockText,
  product_price_calculator: PriceCalculatorBlock,
  highlighted_menu_theme_menu: ThemeMenuFeaturedBlock,
};

export default mappers;

